import styled from 'styled-components'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Helmet } from 'react-helmet'
import LiveTemplateDefault from 'src/components/template/live'
import { selectParams } from 'src/modules/reducers/params'
import { networkLogos } from 'src/constants'
import { createVideoStructuredData } from 'src/modules/utils/videoStructuredData'

export default (props) => {
  // Detect for fox referral and show banner if redirect from fox domain
  const [foxRedirect, setFoxRedirect] = useState(false)
  const params = useSelector(selectParams)

  useEffect(() => {
    const docReferrer = document && document.referrer
    if ((docReferrer && docReferrer.includes('fox')) || params?.fox_redirect === 'true') {
      setFoxRedirect(true)
    }
  }, [params])

  const offerBanner = {
    title: [
      "You've been redirected to Fubo.",
      'Watch live games & dedicated conference coverage for the Big Ten.',
    ],
  }

  const videoStructuredData = createVideoStructuredData({
    networkName: 'Big Ten Network',
    callsign: 'BTN',
    logoUrl: networkLogos.bigten.logoUrl,
    slug: 'big-ten-network',
  })

  return (
    <StyledContainer>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(videoStructuredData)}</script>
      </Helmet>
      <LiveTemplateDefault
        location={props.location}
        lang="en"
        market="us"
        offerBanner={foxRedirect ? offerBanner : null}
        callsign="BTN"
        title="Watch Big Ten Network live with Fubo"
        foxRedirect={foxRedirect}
        networkName="Big Ten Network"
      />
    </StyledContainer>
  )
}

const StyledContainer = styled.div``
